<template>
  <div class="content">
    <div class="content-container">
      <component :is="currentComponent" :key="$route.name" />
    </div>
    <NavInternal :links="links" />
  </div>
</template>

<script lang="ts">
import NavInternal from '@/components/NavInternal.vue'
import BannerImageSection from '@/components/VisualIdentityPage/sections/BannerImageSection.vue'
import ColorsSection from '@/components/VisualIdentityPage/sections/colors/ColorsSection.vue'
import IconographyBannerSection from '@/components/VisualIdentityPage/sections/iconography/IconographyBannerSection.vue'
import PhotographyBannerSection from '@/components/VisualIdentityPage/sections/photography/PhotographyBannerSection.vue'
import GraphicSection from '@/components/VisualIdentityPage/sections/graphics/GraphicsSection.vue'
import GridSection from '@/components/VisualIdentityPage/sections/grid/GridSection.vue'
import IllustrationBannerSection from '@/components/VisualIdentityPage/sections/illustration/IllustrationBannerSection.vue'
import LayoutsSection from '@/components/VisualIdentityPage/sections/layouts/LayoutsSection.vue'
import { Component, Vue } from 'vue-property-decorator'
import TypographyBannerSection from '@/components/VisualIdentityPage/sections/typography/TypographyBannerSection.vue'

@Component({
  components: {
    BannerImageSection,
    NavInternal,
    ColorsSection,
    IconographyBannerSection,
    PhotographyBannerSection,
    GridSection
  }
})
export default class VisualIdentityView extends Vue {
  private routeComponentMap: { [key: string]: any } = {
    'identidade-visual': BannerImageSection,
    'identidade-visual.logo': BannerImageSection,
    'identidade-visual.color': ColorsSection,
    'identidade-visual.typography': TypographyBannerSection,
    'identidade-visual.iconography': IconographyBannerSection,
    'identidade-visual.grafismos': GraphicSection,
    'identidade-visual.ilustracao': IllustrationBannerSection,
    'identidade-visual.photography': PhotographyBannerSection,
    'identidade-visual.grid': GridSection,
    'identidade-visual.layouts': LayoutsSection
  }

  links = [
    { name: 'identidade-visual.layouts', label: 'Identidade Visual' },
    { name: 'identidade-visual.logo', label: 'Logo' },
    { name: 'identidade-visual.color', label: 'Cores' },
    { name: 'identidade-visual.typography', label: 'Tipografia' },
    { name: 'identidade-visual.iconography', label: 'Iconografia' },
    { name: 'identidade-visual.grafismos', label: 'Grafismo' },
    { name: 'identidade-visual.ilustracao', label: 'Ilustrações' },
    { name: 'identidade-visual.photography', label: 'Fotografia' },
    { name: 'identidade-visual.grid', label: 'Grid' }
  ]

  get currentComponent() {
    return this.routeComponentMap[this.$route.name as string] || BannerImageSection
  }
}
</script>

<style lang="scss">
.content {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  .content-container{
    width: 100%;
  }
}
</style>
